import { useUrlFilter } from "@/composables/filter";
import { useRoute } from "vue-router";

/**
 * Collectibles-specific filter composable that adds categoryUrl handling.
 * Wraps the generic useUrlFilter with domain-specific functionality.
 */
export function useCollectiblesFilter() {
  const route = useRoute();

  // Category from route params
  const categoryUrl = computed(() => route.params.categoryUrl as string);

  // Use the generic URL filter
  const urlFilter = useUrlFilter();

  return {
    categoryUrl,
    ...urlFilter,
  };
}
